import * as requestFromServer from './receiptsCrud';
import {callTypes, receiptsSlice} from './receiptsSlice';
import {v4 as guid} from 'uuid';
import {downloadFileHTTPS} from '../../../../utils';
import * as actionsGlobal from '../../_common/actions/globalMessage/showGlobalMessage';
import {messages as M} from '../../../../_metronic/i18n/messages';
import {RequestCancellationManager} from '../../_common/utils/RequestCancellationManager';
import {logUserAction} from '../../../../utils';
import {pages as P} from '../../_common/constants/pages';
import {subjects as S} from '../../_common/constants/subjects';
import {actionTypes as T} from '../../_common/constants/actionTypes';
import {logMessages as L} from '../../_common/constants/logMessages';

export const getReceiptsListIDPrefix = 'getReceiptsList';
const {actions} = receiptsSlice;

const getReceiptsList = storeMethod => queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.list}));

  const requestID = `${getReceiptsListIDPrefix}-${guid()}`;
  const cancellationHandlers = RequestCancellationManager.createCancellationHandlers(requestID);

  return requestFromServer
    .findReceipts(queryParams, cancellationHandlers)
    .then(response => {
      const {errorCode, data: {totalReceiptsCount, pageCount, receiptsList}} = response.data;
      if (errorCode !== 0) throw new Error();

      dispatch(storeMethod({
        totalReceiptsCount,
        pageCount,
        entities: receiptsList
      }));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t find receipts';
      dispatch(actions.catchError({error, callType: callTypes.list}));
    })
    .finally(() => {
      RequestCancellationManager.forgetRequest(requestID);
    });
};

export const downloadReceipt = ({id, name}) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .downloadReceipt(id)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      const fileName = `${name}.pdf`;
      try {
        if (data.downloadLink instanceof Array) {
          data.downloadLink.forEach(link => {
            downloadFileHTTPS(link, fileName);
          });
        } else {
          downloadFileHTTPS(data.downloadLink, fileName);
        }
      } catch (exc) {
        console.error('Save Blob method failed with the following exception.');
        console.error(exc);
      }
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t get file!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const cancelReceipt = ({receiptTypeID, receiptNum, receiptID}) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .cancelReceipt({receiptTypeID, receiptNum})
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.RECEIPTS,
        S.RECEIPT,
        T.EDIT,
        L.RECEIPTS_CANCEL(receiptTypeID, receiptNum),
        errorCode
      );

      if (errorCode === 0) {
        dispatch(actions.cancelReceipt({
          receiptID: receiptID
        }));
        dispatch(actionsGlobal.showGlobalMessage(M.OPERATION_COMPLETED));
      } else {
        dispatch(actionsGlobal.showGlobalMessage(M[errorCode]));
      }

      return errorCode;
    });
};

export const exportReceiptsFileAction = queryParams => dispatch => {
  dispatch(actions.startCall({callType: callTypes.action}));

  return requestFromServer
    .getReceiptsFile(queryParams)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      return data.receiptsList;
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t get file!';
      dispatch(actions.catchError({error, callType: callTypes.action}));
    });
};

export const getReceipts = getReceiptsList(actions.receiptsFetched);
export const getNextReceipts = getReceiptsList(actions.receiptsAppended);
